export default __webpack_public_path__ + "static/media/scrittaGA.342547d8.svg";